import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { GrClose } from 'react-icons/gr';
import PropTypes from 'prop-types';
import '../style/style.css';

export default function DeleteModal({
  id,
  show,
  handleClose,
  handleDelete,
  title,
  body,
  contentTitle,
}) {
  return (
    <Modal
      id={id}
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <GrClose style={{ cursor: 'pointer' }} onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        {body}
        &quot;
        {contentTitle}
        &quot;?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="cancel btn-custom" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="red btn-custom" onClick={handleDelete}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

DeleteModal.propTypes = {
  id: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  contentTitle: PropTypes.string.isRequired,
};
